"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getFontCss: true,
  getAssignmentColor: true
};
exports.getFontCss = exports.getAssignmentColor = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _styledComponents = require("styled-components");
var _default = require("../themes/default");
Object.keys(_default).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _default[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _default[key];
    }
  });
});
var responsiveFontCss = (0, _styledComponents.css)(["@media screen and (max-width:", "){select,textarea,input{font-size:1.6rem;}}font-size:calc( var(--min-size) * 1px + (var(--max-size) - var(--min-size)) * (100vw - (var(--min-viewport) * 1px)) / (var(--max-viewport) - var(--min-viewport)) );line-height:calc( var(--min-line) * 1px + (var(--max-line) - var(--min-line)) * (100vw - (var(--min-viewport) * 1px)) / (var(--max-viewport) - var(--min-viewport)) );@media (min-width:", "px){font-size:calc(var(--max-size) * 1px);line-height:calc(var(--max-line) * 1px);}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mediaQueries.s;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaQueriesValues.xl;
});
var getFontCss = exports.getFontCss = function getFontCss(style) {
  return (0, _styledComponents.css)(["--min-size:", ";--max-size:", ";--min-line:", ";--max-line:", ";", ";", " ", " ", " ", ""], style.size.min, style.size.max, style.line.min, style.line.max, responsiveFontCss, style.fontFamily ? (0, _styledComponents.css)(["font-family:", ";"], style.fontFamily) : '', style.weight ? (0, _styledComponents.css)(["font-weight:", ";"], style.weight) : '', style.letterSpacing ? (0, _styledComponents.css)(["letter-spacing:", "px;"], style.letterSpacing) : '', style.color ? (0, _styledComponents.css)(["color:", ";"], style.color) : '');
};
var getAssignmentColor = exports.getAssignmentColor = function getAssignmentColor(_ref3, assignment) {
  var colors = _ref3.colors;
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (typeof assignment === 'string') {
    return assignment;
  }
  var _assignment = (0, _slicedToArray2["default"])(assignment, 2),
    variant = _assignment[0],
    currentStep = _assignment[1];
  var colorIndex = Object.keys(colors[variant]).indexOf(String(currentStep));
  if (colorIndex === -1) {
    throw new Error('The requested color is not found');
  }
  var colorValues = Object.values(colors[variant]);
  var nextColor = colorIndex + step < 0 ? colorValues[0] : colorIndex + step >= colorValues.length ? colorValues[colorValues.length - 1] : colorValues[colorIndex + step];
  if (!nextColor) {
    throw new Error('The calculated color computed from the step is out of bounds');
  }
  return nextColor;
};
//# sourceMappingURL=theme.js.map